import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'substring',
})
export class SubstringPipe implements PipeTransform {
  transform(value: string, target: 'from' | 'to', char: string): string {
    if (!value || typeof value !== 'string') {
      return value;
    }

    if (target === 'to') {
      return value.split(char)[0];
    } else {
      return value.split(char).pop();
    }
  }
}
